/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import Highlight from 'react-scale/components/elements/highlight';
import ExampleLoading from '../ExampleLoading';

const TaskResponseNER = dynamic(() => import('../tasks/TaskResponseTextNER'), {
  loading: () => <ExampleLoading />,
  ssr: false
});

export const instruction =
  'Please label any people, places, or organizations in the following text.';

export const responseCode = `{
  "response": {
    "annotations": [
      {
        "label": "T_ORG",
        "text": "Hilton's",
        "start": 27,
        "end": 35
      },
      {
        "label": "T_LOC",
        "text": "Paris",
        "start": 104,
        "end": 109
      },
      {
        "label": "T_PERS",
        "text": "Paris Hilton",
        "start": 138,
        "end": 150
      },
    ]
  },
  "task_id": "5795c68afce306120434be64",
  "task": { ... }
}`;

export const code = `client.createNamedentityrecognitionTask({
  callback_url: 'http://www.example.com/callback',
  instruction: '${instruction}',
  params: {
    text: "They were delighted by the Hilton's location: surrounded by vibrant nightlife, and in close proximity to major landmarks in Paris. And as luck would have it, Paris Hilton happened to be staying in the room next door!",
    labels: [
      {
        name: 'T_ORG',
        display_name: 'Organization',
      },
      {
        name: 'T_LOC',
        display_name: 'Location',
      },
      {
        name: 'T_PERS',
        display_name: 'Person',
      },
    ]
  },
}, (err, task) => {
    // do something with task
});`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

export const example = () => <TaskResponseNER />;

export const result = <TaskResponseNER animate />;
